
<template>
  <div>
    <div>
      <!-- {{oneCash}} -->
      <v-form readonly v-if="item && item.data">
        
        <v-text-field readonly :value="Number(item.data.attributes.value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})" prepend-icon="mdi-search" label="Valor"></v-text-field>
        <v-text-field readonly :value="$moment(item.data.attributes.payed_at.substring(0,10)).add(12, 'hour').format('DD/MM/YYYY')" prepend-icon="mdi-search" label="Pago em"></v-text-field>
        
        <v-text-field readonly :value="item.data.attributes.envelope_name || 'Ainda sem envelope' " prepend-icon="mdi-search" label="Envelope"></v-text-field>
        
        <v-text-field readonly :value="solution_map[item.extras.solution]" prepend-icon="mdi-search" label="Solução"></v-text-field>
        <div v-if="item.extras.place_name">
          <v-text-field readonly :value="item.extras.place_name" prepend-icon="mdi-search" label="Local"></v-text-field>
        </div>
        

      </v-form>
      <!-- <cash-profile></cash-profile> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'

export default {
  name: 'CashDetail',
  mixins: [SolutionMap],
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapMutations({
      setOneCash: 'Financial/getOneFinancial'
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneCash: state => state.Financial.oneCash,
    })
  },
  mounted () {
    // this.setOneCash({item: this.item, kind: 'cashes'});
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>